import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model; track item.label) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [root]="true"></li>
            } @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `,
})
export class AppMenu {
    model: MenuItem[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Home',
                items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
            },
            {
                label: 'Store',
                items: [
                    { label: 'Products', icon: 'pi pi-fw pi-shopping-bag', routerLink: ['/products'] },
                    { label: 'Categories', icon: 'pi pi-fw pi-list', routerLink: ['/categories'] },
                    { label: 'Orders', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/orders'] },
                    { label: 'Coupons', icon: 'pi pi-fw pi-tag', routerLink: ['/coupons'] },
                ]
            },
            {
                label: 'Customers',
                items: [
                    { label: 'Users', icon: 'pi pi-fw pi-users', routerLink: ['/users'] },
                    { label: 'Reviews', icon: 'pi pi-fw pi-star', routerLink: ['/reviews'] },
                    { label: 'Newsletter', icon: 'pi pi-fw pi-envelope', routerLink: ['/newsletter'] },
                    { label: 'Send Email', icon: 'pi pi-fw pi-send', routerLink: ['/send-email'] },
                    { label: 'Mailbox', icon: 'pi pi-fw pi-inbox', routerLink: ['/mailbox'] },
                    { label: 'Contact', icon: 'pi pi-fw pi-comments', routerLink: ['/contact'] },
                ]
            },
            {
                label: 'System',
                items: [
                    { label: 'Settings', icon: 'pi pi-fw pi-cog', routerLink: ['/settings'] },
                    { label: 'Shipping', icon: 'pi pi-fw pi-truck', routerLink: ['/shipping'] },
                ]
            }
        ];
    }
}
